const cache = new WeakMap();

export default (study: any, extraData: any) => {
  const displaySets = extraData?.displaySets;
  if (!displaySets) return 0;
  if (cache.has(displaySets)) return cache.get(displaySets);
  
  const result = displaySets.filter((ds: any) => ds.numImageFrames > 0)?.length || 0;
  cache.set(displaySets, result);
  return result;
};
